import { render, staticRenderFns } from "./StatusTile.vue?vue&type=template&id=966adf06&"
import script from "./StatusTile.vue?vue&type=script&lang=js&"
export * from "./StatusTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CPseudoBox: require('@chakra-ui/vue').CPseudoBox, CFlex: require('@chakra-ui/vue').CFlex})
